import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from '../../../../core/services/auth.service';
import { LogService } from '../../../../core/services/log.service';
// import { EventGuestsService } from '../../services/event-guests.service';

import LaguagesListPageView from "./languages-list.page.html";

@Component({
    selector: 'languages-list-page',
    template: LaguagesListPageView
})
export class LanguagesListPage implements OnInit {

    isAllowed: boolean = false;

    constructor(@Inject(AuthService) private authService: AuthService,
        @Inject(LogService) private log: LogService,
        @Inject('$stateParams') private $stateParams: any) {

    }

    ngOnInit() {
        this.isAllowed = this.authService.permissionExist('LANGUAGES_READ') ?? false;

    }

}